<template lang="pug">
v-card.mb-3
  template(v-if="ticket")
    v-card-title.pb-0.subheading {{ticket.id}}: {{ticket.betreff}}
    v-card-text.pt-1
      .d-flexx
        radio-group(label="Status" v-model="status" row :items="statusOptions")
        v-btn(@click="saveStatus" :disabled="status === ticket.status" color="primary") Speichern
      v-layout(row wrap)
        v-flex(xs12 sm6)
          .subheading {{person.vorname ||''}} {{person.nachname || ''}}
          div(v-if="person.telefon") Tel.: {{person.telefon}}
          div(v-if="person.email") E-Mail: {{person.email}}
          .text-wrap-lines.mt-3 {{ticket.textStripped}}
        v-flex(xs12 sm6)
          .mb-3(v-for="projekt in person.projekte")
            .title.mb-1
              | Projekt
            div
              .d-flexx
                div {{projekt.name}}
                v-spacer
                div: v-img(:src="projekt.logo" v-if="projekt.logo" width="100" height="35" position="center right" contain)
              span(v-if="projekt.standort && projekt.standort.aussenstelle")  ({{projekt.standort.aussenstelle}})
            div(v-if="projekt.telefon") Tel.: {{projekt.telefon}}
            div(v-if="projekt.email") E-Mail: {{projekt.email}}
            template(v-if="projekt.standort")
              div(v-if="projekt.standort.strasse") {{projekt.standort.strasse}} {{projekt.standort.hausnummer}}
              div(v-if="projekt.standort.plz || projekt.standort.ort") {{projekt.standort.plz}} {{projekt.standort.ort}}
              div(v-if="projekt.standort.ip") Netz: {{projekt.standort.ip}}
              div(v-if="projekt.standort.bandbreiteAktuell") Bandbreite (Aktuell): {{projekt.standort.bandbreiteAktuell}}
              div(v-if="projekt.standort.bandbreiteMax") Bandbreite (Max): {{projekt.standort.bandbreiteMax}}

            .mb-3
            .title.mb-1 Dienstleister
            .d-flexx.align-end(v-if="projekt.anbieter")
              div
                span.subheading {{projekt.anbieter.name}}
                span(v-if="projekt.anbieter.art")  ({{projekt.anbieter.art.name}})
              v-spacer
              div: v-img(:src="projekt.anbieter.logo" v-if="projekt.anbieter.logo" width="100" height="35" position="center right" contain)
            | Mitarbeiter:
            div(v-if="projekt.anbieter && projekt.anbieter.telefon") Tel.: {{projekt.anbieter.telefon}}
            template(v-for="anbieter in projekt.standort && projekt.standort.itAnbieter || []" v-if="!projekt.anbieter || anbieter.id !== projekt.anbieter.id")
              .d-flexx.align-end
                div
                  span.subheading {{anbieter.name}}
                  span(v-if="anbieter.art")  ({{anbieter.art.name}})
                v-spacer
                div: v-img(:src="anbieter.logo" v-if="anbieter.logo" width="100" height="35" position="center right" contain)
              div(v-if="anbieter.telefon") Tel.: {{anbieter.telefon}}

      //- .title Aufgaben
      //- template(v-for="vorgang in ticket.vargaenge")
        v-layout(row wrap)
          v-flex(xs6): v-autocomplete(label="Art" v-model="vorgang.ticketart" :items="['A', 'B']")
          v-flex(xs6): v-autocomplete(label="Level" v-model="vorgang.level" :items="['1', '2']")
          v-flex(xs6)
            .caption.grey--text.text--darken-1 Priorität
            v-rating(v-model="vorgang.prioritaet" hover)
          v-flex(xs6): select-person(label="Bearbeiter" clearable)

</template>

<script>
import gql from 'graphql-tag'
import GraphqlErrorObject from '../../mixins/graphql-error-object.js'

export default {
  props: ['extra'],
  mixins: [GraphqlErrorObject],
  data() {
    return {
      itTickets: [],
      status: null,
      ticket: null,
      person: null,
      statusOptions: [
        { text: 'Neu', value: 'neu' },
        { text: 'In Bearbeitung', value: 'in_bearbeitung' },
        { text: 'Erledigt', value: 'erledigt' },
        { text: 'Geschlossen', value: 'geschlossen' }
      ]
    }
  },
  apollo: {
    itTickets: {
      query: gql`query($id: ID, $token: String) {
        itTickets(where: { id: $id, apiToken: $token }) {
          id
          status
          betreff
          email
          textStripped
          datum
          vargaenge {
            id
            prioritaet
            ticketart
            level
            user {
              id
              vorname
              nachname
              email
            }
            person {
              id
              vollerName
              email
              telefon
            }
          }
          person {
            id
            vorname
            nachname
            email
            telefon
            projekte {
              id
              name
              telefon
              email
              logo(size: "x35")
              anbieter {
                id
                name
                telefon
                logo(size: "x35")
                art {
                  id
                  name
                }
              }
              standort {
                id
                aussenstelle
                name
                strasse
                hausnummer
                plz
                ort
                bandbreiteMax
                bandbreiteAktuell
                ip
                itAnbieter {
                  id
                  name
                  telefon
                  logo(size: "x35")
                  art {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }`,
      variables() {
        return {
          id: this.$route.query.ticketId,
          token: this.$route.query.ticketToken,
        }
      },
      skip() {
        return !this.$route.query.ticketId || !this.$route.query.ticketToken
      },
      update(response) {
        const tickets = response.itTickets
        this.ticket = tickets[0]
        this.status = this.ticket && this.ticket.status
        this.person = this.ticket && this.ticket.person
        return tickets
      }
    }
  },
  computed: {
  },
  methods: {
    saveStatus() {
      this.gqlClearAllErrors()
      this.$apollo.mutate({
        mutation: gql`mutation ($id: ID!, $status: String) {
          itTicketUpdate(id: $id, status: $status) {
            id
            status
          }
        }`,
        variables: {
          id: this.ticket.id,
          status: this.status
        },
      }).then((response) => {
      }).catch((error) => {
        this.gqlAddErrors(error)
      })
    }
  }
}
</script>
